import server from 'client/js/main/support/server';
import { ReduxAsyncAction } from 'client/js/redux/services/ReduxAsyncAction';
import type { DataAction } from 'client/js/redux/types/dataAction.type';

type FetchAndroidAppNameActionPayload = { androidAppName: string };

const FETCH_ANDROID_APP_NAME_NAMESPACE = 'FETCH_ANDROID_APP_NAME' as const;

const FetchAndroidAppName = new ReduxAsyncAction<
  typeof FETCH_ANDROID_APP_NAME_NAMESPACE,
  string,
  FetchAndroidAppNameActionPayload
>(FETCH_ANDROID_APP_NAME_NAMESPACE);

FetchAndroidAppName.registerRequest(async (packageSlug: string) => {
  // @ts-ignore
  const data = await server('google play load', { value: packageSlug });

  const androidAppName = data.text;

  return { androidAppName };
});

export const FETCH_ANDROID_APP_NAME = FetchAndroidAppName.actionNamespaceConstants;

export const fetchAndroidAppName = FetchAndroidAppName.request;

export type FetchAndroidAppNameResponseAction = DataAction<
  typeof FETCH_ANDROID_APP_NAME.response,
  FetchAndroidAppNameActionPayload
>;
